import script from "./Fd4Annexure.vue?vue&type=script&setup=true&lang=js"
export * from "./Fd4Annexure.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__